import vis from 'vis';
import frenchData from './data-fr';
import germanData from './data-de';
import germanContent from './locales-de';
import frenchContent from './locales-fr';
import createNodesAndEdges from './createNodesAndEdges';
import getOptions from './getOptions';
import overlayButton from './overlayButton';
import localizeContent from './localizeContent';

/* global window, document */

const language = window.location.search.indexOf('lang=fr') > -1 ? 'fr' : 'de';
const data = language === 'fr' ? frenchData : germanData;

// const roles = createRoles(data);
const { nodes, edges } = createNodesAndEdges(data, []);
// console.log('Main: roles are %o, nodes %o, edges %o', roles, nodes, edges);

const nodeDataSet = new vis.DataSet();
nodeDataSet.add(nodes);

const edgeDataSet = new vis.DataSet();
edgeDataSet.add(edges);

const options = getOptions(language);

const container = document.getElementById('network');
// console.log(nodeDataSet, edges, edgeDataSet);
const network = new vis.Network(container, { nodes: nodeDataSet, edges: edgeDataSet }, options);

overlayButton();
const content = language === 'fr' ? frenchContent : germanContent;
localizeContent(content);


// When zooming, diagram overlaps info box: add dark background behind info box
/* const infoBox = document.querySelector('.overlay');
network.on('zoom', (ev) => {
    const opacity = Math.min(Math.max(ev.scale - 0.5, 0), 1);
    infoBox.style.backgroundColor = `rgba(0, 0, 0, ${opacity})`;
}); */

// If diagram is too small, text is not visibile. Zoom in slowly.
function doAnimation() {

    const zoomOptions = {
        position: { x: 0, y: 0 },
        scale: 0.8,
        offset: { x: 0, y: 0 },
        animation: {
            duration: 5000,
            easingFunction: 'easeInOutQuad',
        },
    };

    network.moveTo(zoomOptions);
}

setTimeout(() => {
    doAnimation();
}, 1000);

